import { render, staticRenderFns } from "./ShogiPlayerLib.vue?vue&type=template&id=af938a1e&lang=pug&"
import script from "./ShogiPlayerLib.vue?vue&type=script&lang=js&"
export * from "./ShogiPlayerLib.vue?vue&type=script&lang=js&"
import style0 from "./ShogiPlayerLib.vue?vue&type=style&index=0&id=af938a1e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_webpack@5.86.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports